import { useContext, useState } from "react"

import { HelpBox } from "../../Utilities/Layout"
import { Button, CardBox, CheckboxInput, ChecklistItem } from "@brainfinance/icash-component-library"
import SuccessProductImage from "../../../images/success-product.svg"
import { goToBankingDetails } from "../../../Helpers/Routes"
import { useNavigate } from "react-router-dom"
import { postPaymentVerificationAgree } from "../../../Helpers/Requests"
import { RequestsContext } from "../../../Helpers/Reducers/Requests"
import { UserContext } from "../../../Helpers/Reducers/User"
import { toast } from "react-toastify"

export function PaymentVerification() {
  const navigate = useNavigate()
  const [agreementAccepted, setAgreementAccepted] = useState(false)
  const [isAgreementAcceptedInvalid, setIsAgreementAcceptedInvalid] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const {
    state: { token },
  } = useContext(RequestsContext)
  const {
    state: { user },
  } = useContext(UserContext)

  const onAgreeChange = (value: boolean | undefined) => {
    if (value !== undefined) {
      setAgreementAccepted(value)
      setIsAgreementAcceptedInvalid(false)
    }
  }

  const submitPaymentVerificationAgree = async () => {
    setIsSubmitting(true)
    const result = await postPaymentVerificationAgree(token, user?.applicationId, { agreementAccepted})
    setIsSubmitting(false)
    return result
  }
  return (
    <>
      <div className="flex justify-center mb-8">
        <img src={SuccessProductImage} className="max-h-[176px]" height={176} width={206} alt="bank's services logo" />
      </div>
      <p className="caption-light-no-color !text-[#13141A] !mb-4">
        Your application is on hold while we wait for your payment to appear in your bank account.
      </p>
      <CardBox className="!h-fit">
        <>
          <h3 className="subtitle-light-no-color !text-[#13141A] !mb-2">What happened?</h3>
          <p className="caption-medium !mb-4">
            We have reset your application to the banking step because we were unable to identify your recent iCash
            payment in your bank account.
          </p>
          <h3 className="subtitle-light-no-color !text-[#13141A]">Before you continue:</h3>

          <ChecklistItem className="!mt-2">
            <p className="caption-medium">Log into your online banking</p>
          </ChecklistItem>
          <ChecklistItem className="!mt-2">
            <p className="caption-medium">Check the recent transactions in your account for the iCash payment</p>
          </ChecklistItem>
          <ChecklistItem className="!mt-2">
            <p className="caption-medium">Wait for the payment to be processed (it may take 1-2 business days)</p>
          </ChecklistItem>
        </>
      </CardBox>

      <div className="bg-[#FFCB3D4D] border-[#FFCB3D] border-[1px] rounded-[8px] p-4">
        <p className="caption-medium">
          Our service offers you a comprehensive look at your financial standing including your credit score, payment
          history, credit utilization, account types, and recent inquiries.
        </p>
      </div>

      <div className="mt-6">
        <CheckboxInput
          label=""
          value={agreementAccepted}
          onChange={onAgreeChange}
          className={`!m-0 ${isAgreementAcceptedInvalid ? "loan-cancellation-checkbox" : ""}`}
        >
          <p className={`caption-no-color ${isAgreementAcceptedInvalid ? "!text-red-500" : "caption"} !p-1`}>
            I can see my iCash payment in my bank account transactions
          </p>
        </CheckboxInput>
      </div>

      <Button
        size="large"
        className="!w-full sm:!py-[13px] sm:!text-[16px] !mt-4"
        appearance="primary"
        disabled={isSubmitting}
        onClick={async () => {
          if (!agreementAccepted) {
            setIsAgreementAcceptedInvalid(true)
          } else {
            const result = await submitPaymentVerificationAgree()
            if (result.error) {
              toast(result.error.message || "Something went wrong. Please try again.", { type: "error" })
            } else {
              goToBankingDetails(navigate)
            }
          }
        }}
      >
        Continue
      </Button>

      <HelpBox className="sm:!block !hidden sm:!mt-6" />
    </>
  )
}
